/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PenaltyTier } from './PenaltyTier';
import {
    PenaltyTierFromJSON,
    PenaltyTierFromJSONTyped,
    PenaltyTierToJSON,
} from './PenaltyTier';
import type { InvalidCountRule } from './InvalidCountRule';
import {
    InvalidCountRuleFromJSON,
    InvalidCountRuleFromJSONTyped,
    InvalidCountRuleToJSON,
} from './InvalidCountRule';
import type { VelocityRule } from './VelocityRule';
import {
    VelocityRuleFromJSON,
    VelocityRuleFromJSONTyped,
    VelocityRuleToJSON,
} from './VelocityRule';

/**
 * 
 * @export
 * @interface FraudControlConfig
 */
export interface FraudControlConfig {
    /**
     * 
     * @type {Array<string>}
     * @memberof FraudControlConfig
     */
    alertEmailDistribution: Array<string>;
    /**
     * Ordered lockout/probation ladder. Index 0 is the base tier for a first breach.
     * @type {Array<PenaltyTier>}
     * @memberof FraudControlConfig
     */
    penaltyTiers: Array<PenaltyTier>;
    /**
     * 
     * @type {Array<InvalidCountRule>}
     * @memberof FraudControlConfig
     */
    invalidCountRules: Array<InvalidCountRule>;
    /**
     * Optional single velocity rule. Absent means velocity detection is disabled for the customer.
     * @type {VelocityRule}
     * @memberof FraudControlConfig
     */
    velocityRule?: VelocityRule | null;
}

/**
 * Check if a given object implements the FraudControlConfig interface.
 */
export function instanceOfFraudControlConfig(value: object): value is FraudControlConfig {
    if (!('alertEmailDistribution' in value) || value['alertEmailDistribution'] === undefined) return false;
    if (!('penaltyTiers' in value) || value['penaltyTiers'] === undefined) return false;
    if (!('invalidCountRules' in value) || value['invalidCountRules'] === undefined) return false;
    return true;
}

export function FraudControlConfigFromJSON(json: any): FraudControlConfig {
    return FraudControlConfigFromJSONTyped(json, false);
}

export function FraudControlConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): FraudControlConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'alertEmailDistribution': json['alertEmailDistribution'],
        'penaltyTiers': ((json['penaltyTiers'] as Array<any>).map(PenaltyTierFromJSON)),
        'invalidCountRules': ((json['invalidCountRules'] as Array<any>).map(InvalidCountRuleFromJSON)),
        'velocityRule': json['velocityRule'] == null ? undefined : VelocityRuleFromJSON(json['velocityRule']),
    };
}

export function FraudControlConfigToJSON(value?: FraudControlConfig | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'alertEmailDistribution': value['alertEmailDistribution'],
        'penaltyTiers': ((value['penaltyTiers'] as Array<any>).map(PenaltyTierToJSON)),
        'invalidCountRules': ((value['invalidCountRules'] as Array<any>).map(InvalidCountRuleToJSON)),
        'velocityRule': VelocityRuleToJSON(value['velocityRule']),
    };
}

